import { NgModule } from "@angular/core";
import { PhonePipe } from "./phone.pipe";
import { SafePipe } from "./safe.pipe";
import { NumberPipe } from "./number.pipe";
import { OrderByPipe } from "./orderby.pipe";
import { DateFormatterPipe } from './date-formatter.pipe';
import { HourFormatterPipe } from './hour-formatter.pipe';
import { NumberFormatter } from "./number-formatter.pipe";
import { Nl2BrPipe } from "./nl2br.pipe";

@NgModule({
    declarations : [NumberPipe, PhonePipe, SafePipe, OrderByPipe, DateFormatterPipe, HourFormatterPipe, NumberFormatter, Nl2BrPipe],
    exports : [NumberPipe, PhonePipe, SafePipe, OrderByPipe, DateFormatterPipe, HourFormatterPipe, NumberFormatter, Nl2BrPipe],
    providers: [],
})
export class PipeModule{}